import { useEffect } from 'react';

export function useSEO({ title, description, path }) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name, content) => {
      let el = document.querySelector(`meta[name="${name}"]`) || document.querySelector(`meta[property="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        if (name.startsWith('og:')) {
          el.setAttribute('property', name);
        } else {
          el.setAttribute('name', name);
        }
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('og:title', title);
    setMeta('og:description', description);
    setMeta('og:type', 'website');
    setMeta('og:site_name', 'Conadvy');
    if (path) {
      setMeta('og:url', `https://conadvy.com${path}`);
    }

    return () => {
      document.title = 'Conadvy';
    };
  }, [title, description, path]);
}
